module.exports = __webpack_public_path__ + "img/logo.6196c2b4.png";